import { useQuery } from 'react-query'
import { BASE_API_URL } from 'constants/env'
import { API_METHODS } from 'constants/api-methods'
import { apiHeaders } from 'utils/api-headers'
import { store } from 'index'
import { handleErrors } from 'utils/handle-errors'
import { Ansible } from 'interfaces/ansible'

const fetchAnsibleDetail = async (ansibleId: string): Promise<Ansible> => {
  let response = await fetch(
    `${BASE_API_URL}/api/v4/phone_number_service/ansibles/${ansibleId}`,
    {
      method: API_METHODS.GET,
      headers: apiHeaders(store.getState()),
    }
  )

  response = handleErrors(response)
  return response.json()
}

const useAnsibleDetail = (ansibleId?: string) => {
  return useQuery(
    ['ansible-detail', ansibleId],
    () => fetchAnsibleDetail(ansibleId!),
    {
      enabled: !!ansibleId && ansibleId.length > 0,
      staleTime: 30000,
      retry: 2,
    }
  )
}

export default useAnsibleDetail
